import i18next from "i18next";
export const vatRegistrationFaqs = [
  {
    question: i18next.t("faq_why_i_need_vat_number_question", `{{- q_start}}Why do I need a VAT number?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_why_i_need_vat_number_answer",
      `{{- a_paragraph_start}}Businesses who provide goods or services in a foreign jurisdiction with a VAT regime must comply with the relevant VAT laws of that country. There are several cases where it will be a legal obligation for a company to register for VAT in the country because they are undertaking taxable business activity. Such activity includes:{{- a_paragraph_end}}{{- a_list_start}}Importing goods into the country for sale or distribution{{- a_list_middle}}Buying and selling goods locally{{- a_list_middle}}Selling goods to individuals over the internet (revenue thresholds may apply) Storing goods in a warehouse{{- a_list_middle}}Organising an event in the country (specifically if there is paid admission to the event){{- a_list_middle}}It is the company\u2019s responsibility to register for VAT prior to commencing taxable transactions and once registered, one must comply with the compliance and reporting requirements.{{- a_list_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t("faq_vat_with_fba_services_question", `{{- q_start}}Do I need VAT number if I am using FBA services?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_vat_with_fba_services_answer",
      `{{- a_paragraph_start}}If you store goods in any European country, then you will be required to have a VAT number. It is mandatory by the law.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_when_vat_issued_question", `{{- q_start}}When is my VAT number issued?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_when_vat_issued_answer",
      `{{- a_paragraph_start}}The length of time required to obtain a VAT number varies from country to country. You can typically expect to receive your VAT number within 4 to 6 weeks from the date when your documents are submitted to the tax authority. We will keep in contact with the tax authorities to track the progress of your VAT registration and will keep you informed of any updates. Please see below a list of current timelines for obtaining VAT registrations. We suggest to check back here from time to time as we are constantly monitoring the timeline and will update this frequently:{{- a_paragraph_end}}{{- a_list_start}}France: 7-9 weeks{{- a_list_middle}}Germany: 6 - 8 weeks{{- a_list_middle}}Spain: 1-2 weeks (VIES activation: 2-3 months){{- a_list_middle}}Italy: 4-6 weeks{{- a_list_middle}}Poland: 4-6 weeks{{- a_list_middle}}Czech Republic: 4-6 weeks{{- a_list_middle}}UK: 3-4 weeks{{- a_list_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t("faq_vies_in_spain_question", `{{- q_start}}What do I need to know about the VIES activation process in Spain?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_vies_in_spain_answer",
      `{{- a_paragraph_start}}While the VAT registration is a rather quick process in Spain, the activation of a VAT ID in the {{- link_start}}VIES system{{- link_end}} is a more complex and longer one. After your VAT ID has been issued we can start submitting declarations and you can pay VAT in Spain. Your activation needs to be requested separately from a proposal and can be done only if you carry out intra-community transactions. This means you have to submit an EC Sales List in Spain first. After a Spanish EC Sales List has been filed the proposal can be submitted; however, it will be automatically refused if you have any outstanding liability e.g. VAT payments, VAT returns, penalties. If your proposal is refused it will have to be submitted again starting from the beginning. This process usually takes 2-3 months.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        link_start: '<a class="underline font-semibold" href="https://ec.europa.eu/taxation_customs/vies/" target="_blank" rel="noopener">',
        link_end: "</a>"
      }
    )
  },
  {
    question: i18next.t("faq_documents_while_filing_question", `{{- q_start}}What documents do I need to have with me while filing the registration/questionnaire?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_documents_while_filing_answer",
      `{{- a_paragraph_start}}You will have to fill out your company's details, therefore we suggest that you have the Company Extract, Articles of Association, ID of the legal representative and a Bank Certificate of the company with you.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_how_long_does_the_registration_take_question", `{{- q_start}}How long does the registration process take?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_how_long_does_the_registration_take_answer",
      `{{- a_paragraph_start}}If all information and documents are correctly provided, we can prepare the registration package in a couple of days and send it to the Tax Authority.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_notarisation_and_hague_apostille_meaning_question", `{{- q_start}}What does 'Notarisation' mean and what is a 'Hague Apostille'?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_notarisation_and_hague_apostille_meaning_answer",
      `{{- a_paragraph_start}}Some European tax offices will require that your company documents and registration forms are 'notarised and apostilled' before you can submit them to the authorities to apply for a VAT registration.{{- a_paragraph_middle}}A notarised document is one carrying authenticated signature(s) of the person(s) authorised or required to sign it, and the signature of a notary public witnessing the signature(s), accompanied by an impression of his or her official notary seal. If a tax office requests it, the authorised signatory will need to visit a Notary Public (or have one come to your office) and sign the required documents in his/her presence. The notary will certify the documents after witnessing the signature.{{- a_paragraph_middle}}The definition of an apostille is 'the authentication of a document for use in another country'. The apostille certificate confirms the signature, seal or stamp on a document to be genuine so that it will be accepted when presented in another country within the European Union. It is permanently glued to another document and then an embossing mechanism, often called the apostille seal or apostille stamp, is used to emboss the document with a government crest.{{- a_paragraph_middle}}Usually the notary public you engage for the witnessing service will be able to arrange the apostille for your as well.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_where_can_i_get_my_documents_notarized_question", `{{- q_start}}Where can I get my documents notarized?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_where_can_i_get_my_documents_notarized_answer",
      `{{- a_paragraph_start}}Notaries can authenticate signatures or documents for use abroad. If you need to notarize a documents or Power of Attorney, you must visit a local notary public (or lawyer).{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_where_can_i_get_my_documents_apostilled_question", `{{- q_start}}Where can I get my documents apostilled?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_where_can_i_get_my_documents_apostilled_answer",
      `{{- a_paragraph_start}}Apostilles can usually be arranged by National certified notary offices or the National Public Notary office itself. Spain does not accept a simple notarization and therefore a further authentication / legalization is required, an Apostille Stamp. If your country is not a member of the Apostille Convention, please arrange the local notarization of the required documents and contact the Spanish Consulate in your country to request consular legalization.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_will_original_documents_be_returned_after_registration_question",
      `{{- q_start}}You are asking for original documents--will I have these returned after the registration is completed?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_will_original_documents_be_returned_after_registration_answer",
      `{{- a_paragraph_start}}These documents are requested by the respective tax authorities in each country and are kept by them. Therefore, they cannot be returned to you. To keep the original copies with you, we can also provide notarized copies to the Tax Authority.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_what_is_an_eori_number_question", `{{- q_start}}What is an EORI number?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_what_is_an_eori_number_answer",
      `{{- a_paragraph_start}}An EORI number is a European Union registration business identification number. This number is issued when importing or exporting goods in and out of the EU. A business or individual must obtain an EORI number from a national customs authority before beginning customs activities within the European Union.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_how_many_eoris_do_i_need_question", `{{- q_start}}How many EORI numbers do I need?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_how_many_eoris_do_i_need_answer",
      `{{- a_paragraph_start}}E-commerce sellers only need one EORI number, and in fact can only have one EORI number issued to them. The EORI number can be used in all the EU member states, therefore one number is enough and the Customs services will reject your application if you already have a number issued. Please note that after BREXIT European sellers have to apply for an EORI in the UK, if they want to import goods in the UK. UK based sellers need to apply for an EORI in the EU if they want to import goods in the EU.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_which_countries_eori_number_is_best_to_have_question", `{{- q_start}}Which country's EORI number is the best to have?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_which_countries_eori_number_is_best_to_have_answer",
      `{{- a_paragraph_start}}For EU based companies an EORI number in the country of establishment, for non EU companies the country where you import the most to will be the best country to have an EORI number.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_wrong_registration_info_to_kpmg_question", `{{- q_start}}What happens if I provide wrong information to KPMG when registering?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_wrong_registration_info_to_kpmg_answer",
      `{{- a_paragraph_start}}If the data you provided is not accurate and correct, your account manager will contact you until all the details are clarified. This might prolong the time needed to prepare the registration documents. If the data we filled out on the registration documents is wrong, the Tax Authority will contact us and will not issue the VAT number until all information is accurate and up to date.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_usa_canada_india_china_mexico_australia_japan_support_question",
      `{{- q_start}}Can KPMG support me if I want to register in the USA, Canada, India, China, Mexico, Australia or Japan?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_usa_canada_india_china_mexico_australia_japan_support_answer",
      `{{- a_paragraph_start}}Our office specializes in the European Union; however, we can refer you to our local KPMG offices in those countries. They would be happy to prepare an offer for you and in the case of an agreement, assist you in your business expansion.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_why_do_i_need_a_fiscal_representative_question", `{{- q_start}}Why do I need a fiscal representative?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_why_do_i_need_a_fiscal_representative_answer",
      `{{- a_paragraph_start}}For companies providing goods or services in foreign European countries, there may be a requirement to register for VAT as a non-resident VAT trader. Some countries permit the Non-EU established company to register \u2018directly\u2019 with the tax office, without having to appoint a local representative.{{- a_paragraph_middle}}However, under certain circumstances, the tax authorities will require the company to appoint a Fiscal Representative in the destination country. This company must be tax registered and willing to act as the local representative of the company, managing with queries and filing obligations of the company for dealings with the tax authorities. In most cases, the fiscal representative may be jointly liable for all VAT payments of the company.{{- a_paragraph_middle}}The tax authorities regard a fiscal representative as the local agent of the foreign trader \u2013 which leads to several compliance obligations. Additionally, if the fiscal representative is jointly liable for the trader\u2019s taxes, it is industry practice to require a security deposit or bank guarantee in favour of the fiscal representative to mitigate against potential risks if the company reneges of any liabilities.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_form_6166_apply_question", `{{- q_start}}What is Form 6166? What is it for and how can I apply?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_form_6166_apply_answer",
      `{{- a_paragraph_start}}US based clients are required to provide a 6166 form, issued by the IRS to complete the German registration. The 6166 form can be requested using an 8802 form that can be downloaded from the website of the IRS. Please note that the German Tax Authorities only accept original forms and the issuing time can take up to 3 months for this document. To obtain the form, please apply to the IRS. For more information, please click {{- link_start}}here{{- link_end}}.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        link_start: '<a class="underline" href="https://www.irs.gov/individuals/international-taxpayers/form-6166-certification-of-us-tax-residency" target="_blank" rel="noopener">',
        link_end: "</a>"
      }
    )
  },
  {
    question: i18next.t("faq_companies_articles_and_association_question", `{{- q_start}}What is a company's Articles of Association and why do I need to provide it?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_companies_articles_and_association_answer",
      `{{- a_paragraph_start}}For registering in most European countries, the tax authority requires a document that details the company's shareholder structure, the company's registered capital (funds, not a geographic location) as well as the director and legal representative's information. The document is also known as an Articles of Organization or Articles of Incorporation.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_company_extract_us_question", `{{- q_start}}What is the Company Extract in the US?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_company_extract_us_answer",
      `{{- a_paragraph_start}}A Company Extract or Business License (the name may vary by state) is essentially a document issued by the state in which the company was founded that certifies the legitimacy of the business, that it has been legally registered. It will typically include the company's date of incorporation.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_companys_vat_certificate_us_question", `{{- q_start}}Where can I obtain my company's VAT Certificate in the US?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_companys_vat_certificate_us_answer",
      `{{- a_paragraph_start}}From the IRS. Tax authorities will require documentation from the IRS regarding the issuing of your company's Employer Identification Number (EIN).{{- a_paragraph_end}}`,
      {
        a_paragraph_start: `<p class="mt-2">`,
        a_paragraph_middle: `</p><p class="mt-2">`,
        a_paragraph_end: "</p>",
        a_link_start: `<a class="underline" href="https://www.bundesfinanzministerium.de/Web/DE/Home/home.html" target="_blank" rel="noopener">`,
        a_link_end: `</a>`,
        a_addressline_start: "<p>",
        a_addressline_middle: "</p><p>",
        a_addressline_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_companys_legal_representative_question", `{{- q_start}}Who is the legal representative of my company?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_companys_legal_representative_answer",
      `{{- a_paragraph_start}}The legal representative is the person who holds the legal power to act on the company's behalf  and will represent your company in any tax-related issues. The registration will require a company document which clearly shows who the legal representative is.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_drivers_licence_as_valid_id_question", `{{- q_start}}Can I use a driver's license as a valid form of ID?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_drivers_licence_as_valid_id_answer",
      `{{- a_paragraph_start}}Most European countries require an identification document of the legal representative. It can be an Identity Card, Passport or Driver's License. Please note that for the online registration of a British VAT number, two identification documents will be required.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_bank_certificate_and_bank_details_question", `{{- q_start}}Why do I need to provide a bank certificate and my bank details?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_bank_certificate_and_bank_details_answer",
      `{{- a_paragraph_start}}If you have an overpayment, or you have deductible VAT, some tax authorities may try to transfer back this amount. If your bank details are not provided or are unclear, the tax authority will contact KPMG, thus delaying the processing time. The bank certificate should countain following information: name of bank, address of bank, name of account holder, address of account holder, currency, account number, IBAN, BIC.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_obtain_company_extract_for_uk_company_question", `{{- q_start}}Where can I obtain a company extract for an UK established company?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_obtain_company_extract_for_uk_company_answer",
      `{{- a_paragraph_start}}Contact Companies House on 0303 1234 500 and request them to send a certified copy of your Certificate of Incorporation with the following additional information added:{{- a_paragraph_end}}{{- a_list_start}}Names of the company directors{{- a_list_middle}}Name of the company secretary{{- a_list_middle}}Company registered office{{- a_list_middle}}Issued share capital{{- a_list_middle}}Names of the shareholders{{- a_list_end}}{{- a_paragraph_start}}The above document will be issued for a certain amount. (Around GBP 20, or GBP 60 for a faster service).{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t("faq_vat_certificate_for_uk_company_question", `{{- q_start}}Where can I obtain the VAT certificate of my UK established company?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_vat_certificate_for_uk_company_answer",
      `{{- a_paragraph_start}}This can be requested directly from HM Revenue & Customs on 0300 200 3700. You will need to quote your UK VAT registration number and the document will be posted to your registered address. Please note that it is possible to download a VAT certificate from the online portal where returns are submitted, however this will not be accepted by the tax authorities for VAT registration.{{- a_paragraph_middle}}If you are not registered for VAT in the UK, due to the fact that your sales are below the registration threshold, please let us know by email in advance and we will explain you what to do.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_company_extract_for_uk_based_sole_trader_question", `{{- q_start}}What is the Company Extract for an UK established sole trader?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_company_extract_for_uk_based_sole_trader_answer",
      `{{- a_paragraph_start}}As a sole trader in the UK, it can be more difficult to proof your status. We suggest obtaining a letter from either HM Revenue & Customs or your solicitor or accountant. They should provide you with a letter on their official headed paper indicating the following:{{- a_paragraph_end}}{{- a_list_start}}Your name and address{{- a_list_middle}}Your trading name{{- a_list_middle}}Explicit confirmation that you are a self-employed sole trader{{- a_list_end}}`,
      {
        a_paragraph_start: "<p>",
        a_link_start: `<a class="underline" href="https://www.handelsregister.de/rp_web/welcome.do" target="_blank" rel="noopener">`,
        a_link_end: `</a>`,
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_france_documents_question",
      `{{- q_start}}I wish to register for VAT in France. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_france_documents_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 photocopy of your company extract (Official certificate confirming your business activities){{- a_list_middle}}1 photocopy of the VAT ID certificate (in the country of establishment){{- a_list_middle}}1 photocopy of a bank certificate confirming your banking details{{- a_list_middle}}1 photocopy of the Articles of Association (if available){{- a_list_middle}}1 photocopy (each) of the personal identification document of the legal representative(s){{- a_list_end}}{{- a_paragraph_start}}The company extract, the VAT ID certificate and the bank certificate should not be older than 3 months (at date of submitting the registration package).{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_bank_account_register_vat_in_france_question",
      `{{- q_start}}Is there anything I should be aware of regarding my bank account if I want to register for VAT in France?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_bank_account_register_vat_in_france_answer",
      `{{- a_paragraph_start}}EU based businesses must have a bank account that supports SEPA B2B direct debit payments. If you do not have a SEPA B2B direct debit bank account, the French Tax Authority will issue a penalty on every bank transfer you make (usually EUR 60 per transfer). To avoid such penalties you will have to open a new bank account that is compatible with the French e-payment system.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_uk_documents_quantities_question",
      `{{- q_start}}I wish to register for VAT in the UK. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_uk_documents_quantities_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 photocopy of your company extract (official certificate confirming your business activities){{- a_list_middle}}1 photocopy of the VAT ID certificate (in the country of establishment){{- a_list_middle}}1 photocopy (each) of two different identification documents of the legal representative(s){{- a_list_end}}{{- a_paragraph_start}}The company extract and the VAT ID certificate should not be older than 3 months (at date of submitting the registration package).{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_germany_documents_quantities_question",
      `{{- q_start}}I wish to register for VAT in Germany. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_germany_documents_quantities_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 photocopy of your company extract (Official certificate confirming your business activities){{- a_list_middle}}1 photocopy of the VAT ID certificate (in the country of establishment){{- a_list_middle}}1 photocopy of the Articles of Association (if available){{- a_list_middle}}1 photocopy (each) of the personal identification document of the legal representative(s){{- a_list_end}}{{- a_paragraph_start}}The company extract and the VAT certificate should not be older than 3 months (at date of submitting the registration package).{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_poland_documents_quantities_question",
      `{{- q_start}}I wish to register for VAT in Poland. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_poland_documents_quantities_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 original company extract (Official certificate confirming your business activities){{- a_list_middle}}1 original VAT ID certificate (in the country of establishment){{- a_list_end}}{{- a_paragraph_start}}The company extract and the VAT ID certificate should not be older than 3 months (at date of submitting the registration package).{{- a_paragraph_middle}}Sworn translation of the documents is required. KPMG can arrange this on your behalf.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_czech_republic_documents_quantities_question",
      `{{- q_start}}I wish to register for VAT in the Czech Republic. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_czech_republic_documents_quantities_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 original company extract (Official certificate confirming your business activities){{- a_list_middle}}1 original VAT ID certificate (in the country of establishment){{- a_list_middle}}1 original a bank certificate confirming your banking details, issued by your bank{{- a_list_middle}}1 photocopy (each) of the personal identification document of the legal representative(s){{- a_list_end}}{{- a_paragraph_start}}The company extract, the VAT ID certificate and the bank certificate should not be older than 3 months (at date of submitting the registration package).{{- a_paragraph_middle}}Sworn translation of the documents is required. KPMG can arrange this on your behalf.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_italy_documents_quantities_question",
      `{{- q_start}}I wish to register for VAT in Italy. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_italy_documents_quantities_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 original company extract (Official certificate confirming your business activities){{- a_list_middle}}1 original VAT ID certificate (in the country of establishment){{- a_list_middle}}1 photocopy (each) of the personal identification document of the legal representative(s){{- a_list_end}}{{- a_paragraph_start}}The company extract, the VAT ID certificate and the bank certificate should not be older than 3 months (at date of submitting the registration package){{- a_paragraph_middle}}Sworn translation of the documents is required. KPMG can arrange this on your behalf{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_vat_in_spain_documents_quantities_question",
      `{{- q_start}}I wish to register for VAT in Spain. What company documents should I put together, in what format and what quantities?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_vat_in_spain_documents_quantities_answer",
      `{{- a_paragraph_start}}You need to collect the following documents:{{- a_paragraph_end}}{{- a_list_start}}1 original company extract (Official certificate confirming your business activities) notarized and apostilled{{- a_list_middle}}1 original certificate of Foreigner\u2019s Identification Number (NIE) \u2013 only for sole traders/individuals!{{- a_list_end}}{{- a_paragraph_start}}Your company extract and certificate of NIE should not be older than 3 months (at date of submitting the registration package){{- a_paragraph_middle}}Sworn translation of the documents is required. KPMG can arrange this on your behalf{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-1">`,
        a_paragraph_end: "</p>",
        a_list_start: '<ul class="list-disc my-2 ml-8"><li class="mb-1">',
        a_list_middle: '</li><li class="mb-1">',
        a_list_end: "</li></ul>"
      }
    )
  },
  {
    question: i18next.t(
      "faq_certificate_of_foreigners_identification_number_nie_question",
      `{{- q_start}}What is the Certificate of Foreigner\u2019s Identification Number (NIE) in Spain?{{- q_end}}`,
      {
        q_start: '<p class="pt-2 mr-2">',
        q_end: "</p>"
      }
    ),
    answer: i18next.t(
      "faq_certificate_of_foreigners_identification_number_nie_answer",
      `{{- a_paragraph_start}}Under Spanish law, sole traders/individuals who have an economic relation (activity) with/in the country, but who do not reside in Spain, must apply for a Spanish identification number for foreigners (NIE) at a consulate or representative office of Spain in their country of residence. The NIE-number can be requested by submitting a form called EX-15. You will find more information about the NIE and EX-15 request form {{- link_start}}here{{- link_end}}.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>",
        link_start: '<a class="underline" href="http://www.exteriores.gob.es/Portal/en/ServiciosAlCiudadano/InformacionParaExtranjeros/Paginas/NIE.aspx" target="_blank" rel="noopener">',
        link_end: "</a>"
      }
    )
  },
  {
    question: i18next.t("faq_wrong_registration_document_to_kpmg_question", `{{- q_start}}What happens if I provide wrong documents to KPMG for the VAT registration?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_wrong_registration_document_to_kpmg_answer",
      `{{- a_paragraph_start}}We will ask you to send us the correct documents. If we submit a registration package with wrong documents (e.g. photocopy instead of original or too old) the registration process will be delayed and most probably refused.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("faq_who_is_the_beneficial_owner_question", `{{- q_start}}Who is the beneficial owner?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "faq_who_is_the_beneficial_owner_answer",
      `{{- a_paragraph_start}}{{- a_bold_start}}a){{- a_bold_end}} any natural person who owns or controls {{- a_bold_start}}at least twenty-five per cent of the shares or voting rights{{- a_bold_end}} in a legal person or an unincorporated organization {{- a_bold_start}}directly or{{- a_bold_end}} - by way of the means defined in Subsection (4) of Section 8:2 of Act V of 2013 on the Civil Code (hereinafter referred to as \u201CCivil Code\u201D) - {{- a_bold_start}}indirectly{{- a_bold_end}}, or who is able to exercise effective control over the legal person or unincorporated organization via other means, if that legal person or unincorporated organization is not listed on a regulated market and is subject to disclosure requirements consistent with Community legislation or subject to equivalent international standards,{{- a_paragraph_end}} {{- a_paragraph_start}}{{- a_bold_start}}b){{- a_bold_end}} any natural person who has a dominant influence in a legal person or unincorporated business association as defined in Subsection (2) of Section 8:2 of the Civil Code,{{- a_paragraph_end}} {{- a_paragraph_start}}{{- a_bold_start}}c){{- a_bold_end}} any natural person on whose behalf a transaction is being conducted, or who is able to exercise effective control over the activity of a customer via other means in the case of natural persons,{{- a_paragraph_end}} {{- a_paragraph_start}}{{- a_bold_start}}d){{- a_bold_end}} in the case of foundations:{{- a_paragraph_end}} {{- a_paragraph_start}} da) where the future beneficiaries have already been determined, the natural person who is the beneficiary of twenty-five per cent or more of the property of the foundation,{{- a_paragraph_end}} {{- a_paragraph_start}} db) where the individuals that benefit from the foundation have yet to be determined, the natural person in whose main interest the foundation is set up or operates, or{{- a_paragraph_end}} {{- a_paragraph_start}} dc) the natural person who exercises control in the management of the foundation or exercises control over at least twenty-five per cent of the property of a foundation, and/or who is authorized to represent the foundation,{{- a_paragraph_end}} {{- a_paragraph_start}}{{- a_bold_start}}e){{- a_bold_end}} in the case of fiduciary asset management contracts:{{- a_paragraph_end}} {{- a_paragraph_start}}ea) the principal, and the beneficial owner referred to in Paragraph a) or b) thereof,{{- a_paragraph_end}} {{- a_paragraph_start}}eb) the fiduciary, and the beneficial owner referred to in Paragraph a) or b) thereof,{{- a_paragraph_end}} {{- a_paragraph_start}}ec) the beneficiaries or class of beneficiaries, and the beneficial owner referred to in Paragraph a) or b) thereof, furthermore{{- a_paragraph_end}} {{- a_paragraph_start}}ed) any natural person exercising effective control over the trust fund via other means, furthermore{{- a_paragraph_end}} {{- a_paragraph_start}}{{- a_bold_start}}f){{- a_bold_end}} in the absence of the natural person referred to in Paragraphs a) and b), the executive officer of the legal person or unincorporated business association;{{- a_paragraph_end}}`,
      {
        a_paragraph_start: `<p class="mt-3">`,
        a_paragraph_end: "</p>",
        a_bold_start: `<span class="font-semibold">`,
        a_bold_end: `</span>`
      }
    )
  }
];
export const iossRegistrationFaqs = [
  {
    question: i18next.t("ioss_faq_return_goods_under_ioss_question", `{{- q_start}}How can I return goods under the IOSS scheme?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_return_goods_under_ioss_answer",
      `{{- a_paragraph_start}}Goods returned and shipped out of the EU will qualify for a VAT refund. Please provide KPMG with the necessary information using the data template and KPMG will adjust your IOSS return accordingly.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_do_not_opt_into_ioss_question", `{{- q_start}}What happens if you do not opt into the IOSS?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_do_not_opt_into_ioss_answer",
      `{{- a_paragraph_start}}If IOSS is not used, import VAT is due upon importation of the goods into the EU. Your logistics/customs agent will pay the import VAT to the customs authorities, and then recover it from either the customer or you. Additional handling fees will then usually arise. Additional VAT compliance burden may also arise if the seller sells goods under Delivered Duty Paid (DDP) terms.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_eur_150_value_limit_question", `{{- q_start}}What is the EUR 150 value limit?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_eur_150_value_limit_answer",
      `{{- a_paragraph_start}}Low value goods which qualify for the IOSS are goods in shipments whose intrinsic value at import does not exceed EUR 150 (except products subject to excise duties).{{- a_paragraph_middle}}Intrinsic value means the price of the goods themselves when sold for export to the EU. The price should exclude transport and insurance costs (unless they are included in the price and not indicated separately on the invoice), and exclude any other taxes and charges which can be proved to the customs authorities from any relevant document.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-2">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_currency_other_than_eur_question", `{{- q_start}}My customer pays in a currency other than EUR, what exchange rate should I use?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_currency_other_than_eur_answer",
      `{{- a_paragraph_start}}Where goods sold are paid for in a currency other than the Euro, you should always make the calculation at the time of supply in order to determine whether the sale of goods can be declared under the IOSS.{{- a_paragraph_middle}}To avoid any potential issue at importation due to exchange rate fluctuations, we recommend that you should indicate on the invoice accompanying the shipment the price in EUR, as determined at the moment of acceptance of payment.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-2">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_info_needed_for_kpmg_registration_question", `{{- q_start}}What information do I need to provide to KPMG for the IOSS registration?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_info_needed_for_kpmg_registration_answer",
      `{{- a_paragraph_start}}The exact requirements for the IOSS registration are not yet published by the relevant tax authorities. Please come back to this page later for more information.{{- a_paragraph_middle}}KPMG will also design a questionnaire which will be available on the Portal to collect the necessary information required from you for your IOSS registration.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-2">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_info_needed_for_kpmg_return_question", `{{- q_start}}What information do I need to provide to KPMG for the IOSS return?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_info_needed_for_kpmg_return_answer",
      `{{- a_paragraph_start}}After successful registration, you will be able to download a data template from our Portal. You need to provide your sales (including returns) data regarding the eligible transactions to us in the required template on a monthly basis. KPMG will prepare the IOSS return for your review.{{- a_paragraph_middle}}The IOSS VAT return will contain the total value of the goods sold, their VAT rate and the total VAT amount to be paid, broken down for each EU Member State where the goods are transported to, as well as broken down in terms of standard and reduced rates.{{- a_paragraph_middle}}Upon your approval, KPMG will then submit the return.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-2">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_return_deadline_question", `{{- q_start}}What is the return deadline?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_return_deadline_answer",
      `{{- a_paragraph_start}}You will need to submit a monthly IOSS return to the tax authorities in the country of identification (registration). The deadline for submitting your IOSS VAT return is the end of the calendar month following the reporting period.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_pay_tax_due_question", `{{- q_start}}How do I pay the tax due and what is the payment deadline?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_pay_tax_due_answer",
      `{{- a_paragraph_start}}The deadline for these payments is the end of the month following the reporting month, the same as the return deadline. As you are established outside the EU, you are registered through a VAT intermediary. You should make a monthly payment of VAT due as declared in the IOSS VAT return to the VAT intermediary at least a few working days prior to the payment deadline as instructed. The VAT intermediary will make the payment to the Member State of registration on your behalf.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_ioss_for_b2b_question", `{{- q_start}}Can I use IOSS for B2B transactions?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t("ioss_faq_ioss_for_b2b_answer", `{{- a_paragraph_start}}No, IOSS can only be used for B2C sales of eligible goods.{{- a_paragraph_end}}`, {
      a_paragraph_start: "<p>",
      a_paragraph_end: "</p>"
    })
  },
  {
    question: i18next.t("ioss_faq_appliable_in_uk_no_longer_eu_question", `{{- q_start}}Are these changes appliable to the UK now it is no longer part of the EU?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_appliable_in_uk_no_longer_eu_answer",
      `{{- a_paragraph_start}}The UK left the EU VAT regime on 31st December 2020. At the same time, the UK withdrew its \xA315 low-value consignment relief and introduced a new VAT-at-point-of sale regime (similar to the EU\u2019s IOSS regime) for goods imported into the UK with a shipment value not exceeding \xA3135.{{- a_paragraph_middle}}For sales to EU consumers, British resident sellers are now considered as non-EU residents. From 1 July 2021, they will be able to use the EU IOSS as non-EU sellers, for sales of eligible goods which will be imported into the EU.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_middle: `</p><p class="mt-2">`,
        a_paragraph_end: "</p>"
      }
    )
  },
  {
    question: i18next.t("ioss_faq_who_to_contact_if_question", `{{- q_start}}If I have a question, whom should I contact?{{- q_end}}`, {
      q_start: '<p class="pt-2 mr-2">',
      q_end: "</p>"
    }),
    answer: i18next.t(
      "ioss_faq_who_to_contact_if_answer",
      `{{- a_paragraph_start}}Once you have subscribed to the KPMG services, you will be assigned a dedicated KPMG account manager who will answers your questions regarding the IOSS registration and the compliance process. You can contact your account manager by email or telephone in the following languages: English, German, French, Spanish, Italian and Chinese.{{- a_paragraph_end}}`,
      {
        a_paragraph_start: "<p>",
        a_paragraph_end: "</p>"
      }
    )
  }
];
